import api from './api';

// Create Running Title (Submitted for Approval)
export const createRunningTitle = async (titleData) => {
    try {
        const response = await api.post('/editorialboard/running-titles', titleData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Get Running Titles created by current EB member
export const getMyRunningTitles = async () => {
    try {
        const response = await api.get('/editorialboard/running-titles');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
